import React from 'react'
import { withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom'
/////////////////////////////////////////////////V5CommentStart
// 2021-05-22 - CFlink - sloppy fix to make detroit widget work, not sure what is needed here
/////////////////////////////////////////////////V5CommentEnd

class CFLinkWithoutRouter extends React.Component {
  handleLink = path => {
    this.props.history.push(path)
    this.refresh()  //DDFIX THIS FUCK SHIT CRAP was dying in debugger March 5 2023, this is needed or else main page wont show detroit after you see NEWFINDER
  }

  render() {
    const { to, eventKey, children, onSelect } = this.props
    return (
      <Link
        to={to}
        href={to}
        eventKey={eventKey}
        onSelect={onSelect}
        onClick={() => this.handleLink(to)}
      >
        {children}
      </Link>
    )
  }
}

const CFLink = withRouter(CFLinkWithoutRouter)
export default CFLink



// WEBPACK FOOTER //
// ./src/components/CFLink.js